import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Phone } from "lucide-react";
import { useLang } from "@/lib/i18n";

const CTASection = ({ variant = "default" }) => {
  const { t, lang } = useLang();
  return (
    <section data-testid="cta-section" className="py-24 sm:py-32 relative overflow-hidden">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="relative rounded-3xl border border-white/10 bg-gradient-to-br from-[#0F0F23] via-[#0a0a1a] to-[#050509] p-10 sm:p-16 overflow-hidden">
          <div className="absolute -top-32 -right-32 w-96 h-96 rounded-full bg-[#00D4FF]/10 blur-3xl" />
          <div className="absolute -bottom-24 -left-24 w-80 h-80 rounded-full bg-[#10B981]/8 blur-3xl" />
          <div className="relative grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
            <div>
              <p className="section-overline mb-4">
                {lang === "nl" ? "Klaar om over te stappen?" : "Ready to switch?"}
              </p>
              <h2 className="text-3xl sm:text-5xl font-extrabold tracking-tight text-white leading-[1.05]">
                {lang === "nl" ? (
                  <>Uw vloot verdient<br /><span className="text-[#00D4FF]">een vaste schoonmaakpartner</span>.</>
                ) : (
                  <>Your fleet deserves<br /><span className="text-[#00D4FF]">a dedicated cleaning partner</span>.</>
                )}
              </h2>
              <p className="mt-6 text-white/60 text-base sm:text-lg max-w-xl leading-relaxed">
                {lang === "nl"
                  ? "Vraag een gerichte offerte aan voor uw wagenpark of plan een korte demo van WaszBase. Wij reageren binnen één werkdag — meestal sneller."
                  : "Request a quote tailored to your fleet or schedule a short WaszBase demo. We respond within one business day — usually faster."}
              </p>
            </div>
            <div className="flex flex-col gap-4">
              <Link to="/contact?type=quote" data-testid="cta-quote">
                <button className="btn-primary w-full justify-between">
                  <span>{t("hero.cta_primary")}</span>
                  <ArrowRight className="w-4 h-4" />
                </button>
              </Link>
              <Link to="/waszbase" data-testid="cta-demo">
                <button className="btn-secondary w-full justify-between">
                  <span>{t("hero.cta_demo")}</span>
                  <ArrowRight className="w-4 h-4" />
                </button>
              </Link>
              <a href="tel:0365255021" data-testid="cta-call" className="text-center text-sm text-white/50 hover:text-[#00D4FF] inline-flex items-center justify-center gap-2 pt-2">
                <Phone className="w-3.5 h-3.5" /> 036 525 5021
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
